import {SEARCH_COUNT_PAYLOAD} from '../Types/types'

export function storeSearchCount(data: any) {
  return {
    type: SEARCH_COUNT_PAYLOAD,
    payload: data
  }
}
